import React from 'react';
import { observer } from 'mobx-react';

import { IXAxisProps, IYAxisProps } from '../../../models/charting/index.js';
import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import ChartBase from '../ChartBase/ChartBase.js';
import { getChartBaseProps } from '../ChartBase/ChartBaseFunctions.js';
import { IChartBaseProps } from '../ChartBase/models/index.js';
import { TSingleChartElement } from '../ChartBase/models/TSingleChartElement.js';

import { IAreaChartConfiguration, IAreaChartProps, IAreaChartState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { AREA_CHART_CATEGORY_KEY, AREA_CHART_COMPONENT_KEY } from './AreaChart.meta.js';

export class AreaChart extends ComponentBase<IAreaChartProps, IAreaChartState, IAreaChartConfiguration> {
	categoryKey = AREA_CHART_CATEGORY_KEY;
	componentKey = AREA_CHART_COMPONENT_KEY;

	constructor(props: IAreaChartProps) {
		super(props);
	}
	get chartBaseProps(): IChartBaseProps {
		const { elementOverrides, dateOptions } = this.props;
		let data = this.props.data;
		if (elementOverrides) {
			const { xAxis, yAxis } = elementOverrides;
			if (dateOptions) {
				if (xAxis && dateOptions.xAxisDateAsNumber) {
					data = this.useDateAsNumber(xAxis);
				}
				if (yAxis && dateOptions.yAxisDateAsNumber) {
					data = this.useDateAsNumber(yAxis);
				}
			}
		}

		return getChartBaseProps({ type: 'Area' }, this.configuration, {
			...this.props,
			data,
		});
	}

	useDateAsNumber(axis: TSingleChartElement<IXAxisProps> | TSingleChartElement<IYAxisProps>) {
		const response: any[] = [];
		const { data } = this.props;
		if (data) {
			if (axis.dataKey) {
				axis.type = 'number';
				for (const element of data) {
					const clone: any = Object.assign({}, element);
					let value = clone[axis.dataKey as string];
					value = new Date(value).getTime();
					clone[axis.dataKey as string] = value;
					response.push(clone);
				}
			} else {
				response.push(...data);
			}
		}
		return response;
	}

	render() {
		const { className } = this.props;
		return (
			<Wrapper className={className}>
				<ChartBase {...this.chartBaseProps} />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(AreaChart), AREA_CHART_CATEGORY_KEY, AREA_CHART_COMPONENT_KEY);
